import { html, nothing, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { customElement } from '../../base-element';
import { PopoverBaseWC } from './popover-base.wc';
import styles from './popover.scss?inline';

@customElement('ps-popover')
export class PopoverWC extends PopoverBaseWC {
  static styles = unsafeCSS(styles);

  /**
   * Popover size
   */
  @property({ reflect: true }) size: 'none' | 'xsmall' | 'small' | 'large' =
    'large';

  /** The distance in pixels from which to offset the panel away from its anchor. */
  @property({ type: Number }) distance = 8;

  /* The distance in pixels from which to offset the panel along its anchor. */
  @property({ type: Number }) skidding = 8;

  constructor() {
    super();

    this.hasArrow = true;
  }

  render() {
    return html`
      <div
        id="popover-container"
        class=${classMap({
          'c-popover': true,
          'c-popover--active': this.active,
          [`c-popover--${this.width}-width`]: this.width,
          [`c-popover--size-${this.size}`]: this.size,
        })}
        style="transform: ${this.transform}"
        part="container"
      >
        <slot class="c-popover__body" part="body"></slot>
        ${this.hasArrow
          ? html`<div class="c-popover__arrow" id="popover-arrow"></div>`
          : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-popover': PopoverWC;
  }
  enum PSElementTagNameMap {
    'ps-popover' = 'ps-popover',
  }
}
